import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'src/shared/pipes/pipes.module';
import { TypeSafeMatCellDefModule } from '../type-safe-mat-cell-def/type-safe-mat-cell-def.module';
import { FutureBidsListComponent } from './future-bids-list.component';
import { TableViewsMenuModule } from '../table-view/table-views-menu/table-views-menu.module';
import { FormulaPriceComponent } from '../formula-price';
import { FutureBidStatusComponent } from '../future-bid-status';
import { InlineEditorModule } from '../inline-editor/inline-editor.module';
import { StickyColumnsDirective } from 'src/directives/sticky-columns/sticky-columns.directive';

@NgModule({
  declarations: [FutureBidsListComponent],
  exports: [FutureBidsListComponent],
  imports: [
    StickyColumnsDirective,
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    PipesModule,
    RouterModule,
    TypeSafeMatCellDefModule,
    TableViewsMenuModule,
    FormulaPriceComponent,
    FutureBidStatusComponent,
    InlineEditorModule,
  ],
})
export class FutureBidsListModule {}
